const { VUE_APP_SITE_ID='' } = window.env
export const LS_WECHAT_USER_INFO_KEY = '$WECHAT_USER_INFO'
export const ADDRESS_LIST = VUE_APP_SITE_ID + 'Address'
export const ORDER_ID = VUE_APP_SITE_ID + 'ORDERID'
export const UAID = 'UA-' + VUE_APP_SITE_ID
